import React, { Component } from 'react';
import { BrowserRouter, HashRouter, Route, Switch, Link } from 'react-router-dom';
import { Layout, Menu } from 'antd';

import SearchWordSpider from '../page/inspiration/searchWordSpider'
// import HomePageRecommendation from '../page/inspiration/homePageRecommendation';
// import EsDataManager from '../page/inspiration/esDataManager';
// import Upload from '../page/inspiration/upload';
import HotWord from '../page/inspiration/hotWord';
import AtlasManager from '../page/inspiration/atlasManager';
import AtlasList from '../page/inspiration/atlasList';
// import ImgDelete from '../page/inspiration/imgDelete';
// import SearchWordsManager from '../page/inspiration/searchWordsManager';
import TagManager from '../page/inspiration/tagManager';
import KnowledgeSystemMaintenance from '../page/inspiration/knowledgeSystemMaintenance';
// import CrawlerComment from '../page/inspiration/crawlerComment';
import insGroup from '../page/inspiration/insGroup';
import AuditMarking from '../page/inspiration/newAuditMarking';
import ImgQuality from '../page/inspiration/imgQuality';
// import TodayRecommendIndustryTrends from '../page/inspiration/todayRecommendIndustryTrends';
// import InspireAndCase from '../page/inspiration/inspireAndCase';
// import EditInspireAndCase from '../page/inspiration/editInspireAndCase';
import NodeManage from '../page/inspiration/nodeManage';
// import SpiderTools from '../page/inspiration/spiderTools';
// import SpiderToolDetail from '../page/inspiration/spiderToolDetail/index';
import ImgAudit from '../page/inspiration/imgAudit';
import ClassifyImgAudit from '../page/inspiration/classifyImgAudit';
import ClassifyAudit from '../page/inspiration/classifyAudit';
import classifyAudit4Old from '../page/inspiration/classifyAudit4Old'
import classifyAudit4Old_Old from '../page/inspiration/classifyAudit4Old/old'
import DelIns from '../page/inspiration/delIns'
import RightDel from '../page/inspiration/rightDel'
import BanListAudit from '../page/inspiration/banListAudit'
import Ontology from '../page/inspiration/ontology'
import OntologyPropertyManager from '../page/inspiration/ontology/propertyManager'
import OtherWordsManager from '../page/inspiration/ontology/otherWordsManager'
import OntologyBrushData from '../page/inspiration/ontology/brushData'


const { Content, Sider } = Layout
const SubMenu = Menu.SubMenu

export default class Inspiration extends Component {
  state = {
    permissions: localStorage.getItem('permissions') && localStorage.getItem('systemType') === 'inspiration',
    collapsed: false,
    contentLeft: 200, //内容距离左侧距离
  }

  onCollapse = (collapsed) => {
    this.setState({
      contentLeft: collapsed ? 80 : 200,
      collapsed,
    })
  }

  logout = () => {
    localStorage.removeItem('username')
    localStorage.removeItem('password')
    localStorage.removeItem('permissions')
    window.location.href = '/'
  }

  render() {
    const { contentLeft, permissions } = this.state
    return (
      <HashRouter basename={window.__POWERED_BY_QIANKUN__ ? '/manager-linggan' : '/'}>
        {/* <LoginStatus systemType='linggan' /> */}
        <Layout>
          <Sider
            style={{
              overflow: 'auto',
              height: '100vh',
              position: 'fixed',
              left: 0,
            }}
            collapsible
            collapsed={this.state.collapsed}
            onCollapse={this.onCollapse}
          >
            <div className='logo'>
              <img width={120} src="https://znztv-image.oss-cn-shanghai.aliyuncs.com/userFace/logo_w.png" alt='' />
              <span style={{ color: '#fff', cursor: 'pointer', position: 'absolute', left: 20, top: 50 }} onClick={this.logout}>注销</span>
            </div>
            <Menu theme={'dark'} mode={'inline'}>
              {permissions ? (
                <SubMenu title='图片管理'>
                  <Menu.Item>
                    <Link to={'/inspiration/delIns'}>
                      图片删除
                    </Link>
                  </Menu.Item>
                  <Menu.Item>
                    <Link to={'/inspiration/imgQuality'}>
                      图片列表
                    </Link>
                  </Menu.Item>
                  <Menu.Item>
                    <Link to={'/inspiration/searchWordSpider'}>图片抓取</Link>
                  </Menu.Item>
                  <Menu.Item>
                    <Link to={'/inspiration/imgAudit'}>爬取审核</Link>
                  </Menu.Item>
                  <Menu.Item>
                    <Link to={'/inspiration/classifyAudit'}>分类审核</Link>
                  </Menu.Item>
                  <Menu.Item>
                    <Link to={"/inspiration/classifyAudit4Old"}>老图审核</Link>
                  </Menu.Item>
                  <Menu.Item>
                    <Link to={"/inspiration/classifyImgAudit"}>瀑布流审核</Link>
                  </Menu.Item>
                  {/* <Menu.Item>
                      <Link to={'/inspiration/searchWordsManager'}>搜索词管理</Link>
                    </Menu.Item>
                    <Menu.Item>
                      <Link to={'/inspiration/homePageRecommendation'}>首页推荐管理</Link>
                    </Menu.Item>
                    <Menu.Item>
                      <Link to={'/inspiration/esDataManager'}>删除图片和图集</Link>
                    </Menu.Item>
                    <Menu.Item>
                      <Link to={'/inspiration/upload'}>上传管理</Link>
                    </Menu.Item>
                    <Menu.Item>
                      <Link to={'/inspiration/imgDelete'}>图片删除</Link>
                    </Menu.Item>
                    <Menu.Item>
                      <Link to={'/inspiration/crawlerComment'}>爬取图片评价</Link>
                    </Menu.Item> */}
                  <Menu.Item>
                    <Link to={'/inspiration/auditMarking'}>
                      打标评星
                    </Link>
                  </Menu.Item>
                </SubMenu>
              ) : null}
              {permissions ? (
                <SubMenu title="图集管理">
                  <Menu.Item>
                    <Link to={'/inspiration/atlasList'}>图集列表</Link>
                  </Menu.Item>
                  <Menu.Item>
                    <Link to={'/inspiration/atlasManager'}>图集推荐</Link>
                  </Menu.Item>
                  {/* <Menu.Item>
                      <Link to={'/inspiration/todayRecommendIndustryTrends'}>
                        今日推荐/行业趋势
                      </Link>
                    </Menu.Item>
                    <Menu.Item>
                      <Link to={'/inspiration/inspireAndCase/2'}>
                        灵感/案例
                      </Link>
                    </Menu.Item> */}
                  <Menu.Item>
                    <Link to={'/inspiration/insgroup'}>套图管理</Link>
                  </Menu.Item>
                </SubMenu>
              ) : null}
              {permissions ? (
                <SubMenu title="知识体系">
                  <Menu.Item>
                    <Link to={'/inspiration/KnowledgeSystemMaintenance'}>
                      知识体系维护
                    </Link>
                  </Menu.Item>
                  <Menu.Item>
                    <Link to={'/inspiration/nodeManage'}>
                      节点管理
                    </Link>
                  </Menu.Item>
                </SubMenu>
              ) : null}
              {permissions ? (
                <SubMenu title="标签管理">
                  {/* <Menu.Item>
                      <Link to={'/inspiration/spiderTools'}>工具列表</Link>
                    </Menu.Item> */}
                  <Menu.Item>
                    <Link to={'/inspiration/tagManager'}>标签列表</Link>
                  </Menu.Item>
                </SubMenu>
              ) : null}
              {permissions ? (
                <SubMenu title="页面管理">
                  <Menu.Item>
                    <Link to={'/inspiration/hotWord'}>热词管理</Link>
                  </Menu.Item>
                </SubMenu>
              ) : null}
              <SubMenu title='本体库'>
                <Menu.Item>
                  <Link to={'/inspiration/ontology'}>分类管理</Link>
                </Menu.Item>
                <Menu.Item>
                  <Link to={'/inspiration/ontology/propertyManager'}>属性管理</Link>
                </Menu.Item>
                <Menu.Item>
                  <Link to={'/inspiration/ontology/otherWordsManager'}>补充标签管理</Link>
                </Menu.Item>
                <Menu.Item>
                  <Link to={'/inspiration/ontology/brushData'}>刷数据</Link>
                </Menu.Item>
              </SubMenu>
              <SubMenu title='用户管理'>
                <Menu.Item>
                  <Link to={'/inspiration/rightDel'}>权益管理</Link>
                </Menu.Item>
                <Menu.Item>
                  <Link to={'/inspiration/banListAudit'}>黑名单管理</Link>
                </Menu.Item>
              </SubMenu>
            </Menu>
          </Sider>
          <Layout style={{ marginLeft: contentLeft }}>
            <Content style={{ margin: '10px 16px 0', overflow: 'initial' }}>
              <Switch>
                <Route
                  exact
                  path='/inspiration/searchWordSpider'
                  component={SearchWordSpider}
                />
                {/* <Route
                    exact
                    path='/inspiration/homePageRecommendation'
                    component={HomePageRecommendation}
                  />
                  <Route
                    exact
                    path='/inspiration/esDataManager'
                    component={EsDataManager}
                  />
                  <Route
                    exact
                    path='/inspiration/upload'
                    component={Upload}
                  /> */}
                <Route
                  exact
                  path='/inspiration/hotWord'
                  component={HotWord}
                />
                <Route
                  exact
                  path='/inspiration/atlasList'
                  component={AtlasList}
                />
                <Route
                  exact
                  path='/inspiration/atlasManager'
                  component={AtlasManager}
                />
                {/* <Route
                    exact
                    path='/inspiration/imgDelete'
                    component={ImgDelete}
                  />
                  <Route
                    exact
                    path='/inspiration/searchWordsManager'
                    component={SearchWordsManager}
                  /> */}
                <Route
                  exact
                  path='/inspiration/tagManager'
                  component={TagManager}
                />
                <Route
                  exact
                  path='/inspiration/knowledgeSystemMaintenance'
                  component={KnowledgeSystemMaintenance}
                />
                {/* <Route
                    exact
                    path='/inspiration/crawlerComment'
                    component={CrawlerComment}
                  /> */}
                <Route
                  exact
                  path='/inspiration/insgroup'
                  component={insGroup}
                />
                <Route
                  exact
                  path='/inspiration/auditMarking'
                  component={AuditMarking}
                />
                <Route
                  exact
                  path='/inspiration/imgQuality'
                  component={ImgQuality}
                />
                {/* <Route
                    exact
                    path='/inspiration/todayRecommendIndustryTrends'
                    component={TodayRecommendIndustryTrends}
                  />
                  <Route
                    exact
                    path='/inspiration/inspireAndCase/:recommendType'
                    component={InspireAndCase}
                  />
                  <Route
                    exact
                    path='/inspiration/editInspireAndCase/:id/:recommendType'
                    component={EditInspireAndCase}
                  /> */}
                <Route
                  exact
                  path="/inspiration/nodeManage"
                  component={NodeManage}
                />
                {/* <Route
                    exact
                    path="/inspiration/spiderTools"
                    component={SpiderTools}
                  />
                  <Route
                    exact
                    path="/inspiration/spiderToolDetail/:id"
                    component={SpiderToolDetail}
                  /> */}
                <Route
                  exact
                  path="/inspiration/imgAudit"
                  component={ImgAudit}
                />
                <Route
                  exact
                  path="/inspiration/classifyAudit"
                  component={ClassifyAudit}
                />
                <Route
                  exact
                  path="/inspiration/classifyAudit4Old"
                  component={classifyAudit4Old}
                />
                <Route
                  exact
                  path="/inspiration/classifyAudit4Old/old"
                  component={classifyAudit4Old_Old}
                />
                <Route
                  exact
                  path="/inspiration/delIns"
                  component={DelIns}
                />
                <Route
                  exact
                  path="/inspiration/rightDel"
                  component={RightDel}
                />
                <Route
                  exact
                  path="/inspiration/banListAudit"
                  component={BanListAudit}
                />
                <Route
                  exact
                  path="/inspiration/classifyImgAudit"
                  component={ClassifyImgAudit}
                />
                <Route
                  exact
                  path="/inspiration/ontology"
                  component={Ontology}
                />
                <Route
                  exact
                  path="/inspiration/ontology/propertyManager"
                  component={OntologyPropertyManager}
                />
                <Route
                  exact
                  path="/inspiration/ontology/otherWordsManager"
                  component={OtherWordsManager}
                />
                <Route
                  exact
                  path="/inspiration/ontology/brushData"
                  component={OntologyBrushData}
                />
              </Switch>
            </Content>
          </Layout>
        </Layout>
      </HashRouter>
    )
  }
}